const isPreviewOrLocalHost = (): boolean => {
    if (typeof window === 'undefined') return false;

    const hostname = window.location.hostname.toLowerCase();
    const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
    if (isLocalhost) return true;

    const isFirebasePreviewChannelHost = (
        (hostname.endsWith('.web.app') || hostname.endsWith('.firebaseapp.com'))
        && hostname.includes('--')
    );
    return isFirebasePreviewChannelHost;
};

const isTestMode = (): boolean => (
    process.env.NODE_ENV === 'development'
    || (
        process.env.REACT_APP_USE_PREVIEW_STAGING_DATA === 'true'
        && isPreviewOrLocalHost()
    )
);

export default isTestMode;
